export default {
  state: {
    tags: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/TagsStore.js